import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Wrapper = styled.div`
  width: 20px;
  height: 20px;
  svg {
    width: 100%;
  }

  animation: ${rotate} 1s linear infinite;
`;
